<template>
    <div>
        <h2 class="font-weight-regular">{{ shift.startDatetime | moment("dddd, MMMM D") }}</h2>
        <h2 v-if="shift.workerName">
            {{ shift.shiftRole }} |
            <EmployeeName :name="shift.workerName" :employeeId="shift.userId" :link="user.clientOrHigher" />
            <v-tooltip top>
                <v-icon large v-if="shift.employeeAbsent" color="warning" slot="activator"> warning </v-icon>
                <span>Employee was absent</span>
            </v-tooltip>
        </h2>
        <h2 v-else>
            {{ shift.shiftRole }}
        </h2>
        <div class="subtle" v-if="shift.requiredSkills && shift.requiredSkills.length > 0">
            Skills required:
            <div class="inline-list">
                <span v-for="skill in shift.requiredSkills">{{ skill.name }}</span>
            </div>
        </div>
        <h2 class="grey--text font-weight-regular">{{ shift.startDatetime | moment("h:mma") }} - {{ shift.endDatetime | moment("h:mma") }}</h2>
        <h2 class="grey--text font-weight-regular">
            <router-link v-if="user.managerOrHigher" :to="{ name: 'clientBusinessDetail', params: { clientBusinessId: shift.clientBusinessId } }">
                {{ shift.location }}
            </router-link>
            <router-link v-else :to="{ name: 'worksiteShow', params: { worksiteId: shift.worksiteId } }">
                {{ shift.location }}
            </router-link>
        </h2>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    props: ["shift"],
    components: {},
    computed: {
        ...mapState("userAuth", ["user"]),
        exampleComputed: function () {
            return this.example;
        },
    },
    created() {},
    watch: {},
    data: function () {
        return {
            example: "test",
        };
    },
    methods: {
        exampleMethod() {},
    },
};
</script>

<style scoped></style>
